var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiplomado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_21",
    "data-name": "Grupo 21",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.897,
    height: 13.611,
    viewBox: "0 0 21.897 13.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41",
    "data-name": "Trazado 41",
    d: "M6.847,222.588l-2.874,1.073L0,225.144l5.173,1.93.214.079,2.994,1.118,2.567.958,2.927-1.092h0l2.635-.984.686-.255,4.7-1.753h0L16.938,223.3l0,0h0l-3.421-1.276h0v0h0l-2.556-.953v0Z",
    transform: "translate(0 -221.059)",
    fill: "#f49a3f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42",
    "data-name": "Trazado 42",
    d: "M6.391,228.842v2.191a2.857,2.857,0,0,0,1.614,2.331,7.8,7.8,0,0,0,3.948.979c.2,0,.4-.007.588-.019a7.176,7.176,0,0,0,3.716-1.2,2.661,2.661,0,0,0,1.258-2.1v-.005h0v-2.186l-5.563,2.076Z",
    transform: "translate(-1.005 -222.282)",
    fill: "#f49a3f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43",
    "data-name": "Trazado 43",
    d: "M4.885,233.565l0-.029-.18-1.875-.008-.082-.087-.9H4.68v-1A.493.493,0,0,0,4.8,229.1a.5.5,0,0,0-.234-.236v-1.22l-.436-.163v1.387a.493.493,0,0,0-.108.807v1H4.1l-.053.54-.066.672-.162,1.656v.006l-.089.9-.078.8a.231.231,0,0,0,0,.054c.026.221.36.387.745.372s.677-.206.651-.426Z",
    transform: "translate(-0.574 -222.067)",
    fill: "#f49a3f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiplomado);
export default __webpack_public_path__ + "static/media/diplomado.3e44fc85fe5dfcdc4dd87b368f52b254.svg";
export { ForwardRef as ReactComponent };